import React, { useEffect, useState } from 'react';
import { Button, Box, Text } from 'theme-ui';

const styles = {
  container: {
    position: 'fixed',
    left: 0,
    bottom: 0,
    width: '100%',
    'z-index': 100,
  },
  box: {
    width: '90%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: ['column', null, 'row'],
    alignItems: 'center',
    justifyContent: [null, null, 'flex-start', 'space-between'],
    background: '#4B5667',
    borderRadius: '15px',
    marginBottom: '10px',
    padding: '20px 30px',
    color: '#FFFFFF',
  },
  text: {
    width: ['100%', '100%', '60%', '70%'],
  },
  linkBox: {
    display: 'flex',
    flexDirection: 'flex-row',
    alignItems: 'center',
    width: ['100%', '100%', '40%', '30%'],
    justifyContent: ['space-between', null, null, 'space-around'],
    marginLeft: [null, null, '3rem', null],
  },
  link: {
    color: 'inherit',
    textDecoration: 'none',
    width: 'auto',
    '&: visited': {
      color: 'rgba(255,255,255, 0.7)',
    },
    '&:hover': {
      scale: '1.1',
      transition: 'all 300ms',
    },
  },
  button: {
    color: '#4B5667',
    paddingTop: ['0.2rem', '0.5rem', '0.8rem', '0.8rem'],
    paddingBottom: ['0.2rem', '0.5rem', '0.8rem', '0.8rem'],
    paddingLeft: ['0.5rem', '1rem', '1.5rem', '2rem'],
    paddingRight: ['0.5rem', '1rem', '1.5rem', '2rem'],
    width: 'auto',
    fontSize: '1rem',
  },
};

const CookieBanner = () => {
  const [accepted, setAccepted] = useState(undefined);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.gtag) return;
    
    window.gtag('consent', 'default', {
      ad_storage: 'denied',
      analytics_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
    });

    const storedConsent = localStorage.getItem('accepted');
    if (storedConsent === null) {
      setAccepted(null);
      return;
    }

    const isAccepted = /true/i.test(storedConsent);
    setAccepted(isAccepted);

    window.gtag('consent', 'update', {
      ad_storage: isAccepted ? 'granted' : 'denied',
      analytics_storage: isAccepted ? 'granted' : 'denied',
      ad_user_data: isAccepted ? 'granted' : 'denied',
      ad_personalization: isAccepted ? 'granted' : 'denied',
    });
  }, []);

  const handleConsent = (isAccepted) => {
    localStorage.setItem('accepted', isAccepted.toString());
    setAccepted(isAccepted);

    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('consent', 'update', {
        ad_storage: isAccepted ? 'granted' : 'denied',
        analytics_storage: isAccepted ? 'granted' : 'denied',
        ad_user_data: isAccepted ? 'granted' : 'denied',
        ad_personalization: isAccepted ? 'granted' : 'denied',
      });
    }
  };

  return (
    accepted === null && (
      <Box sx={styles.container}>
        <Box sx={styles.box}>
          <Text sx={styles.text}>
            We use cookies to analyse our traffic. We also share information
            about your use of our site with our advertising and analytics
            partners who may combine it with other information that you`ve
            provided to them or that they`ve collected from your use of their
            services.
          </Text>
          <Box sx={styles.linkBox}>
            <Button sx={styles.button} variant="icon" onClick={() => handleConsent(false)}>
              Reject
            </Button>
            <Button sx={styles.button} variant="icon" onClick={() => handleConsent(true)}>
              Allow
            </Button>
          </Box>
        </Box>
      </Box>
    )
  );
};

export default CookieBanner;
